import { render } from "./promise.vue?vue&type=template&id=5ed764ba&scoped=true"
import script from "./promise.vue?vue&type=script&lang=js"
export * from "./promise.vue?vue&type=script&lang=js"

import "./promise.vue?vue&type=style&index=0&id=5ed764ba&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed764ba"]])

export default __exports__